import { Document, Text, View } from "@react-pdf/renderer";
import PageLayout from "../../components/Contract/contractPdf/contractService/PageLayout";

export default function FinalVRFDownload(data) {
  console.log("idididid.....PDF ....", data);
  const propData = data.data;
  console.log("propData......PDF......", propData);
  return (
    <>
      <Document>
        <PageLayout pageNo={1}>
          <View style={{ borderBottom: 1, marginTop: 0 }}>
            {/* row 1 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 1.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>1</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Reference No.</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.vrf_reference_number}</Text>
              </View>
            </View>
            {/* row 2 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>2</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Provider</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.company_name}</Text>
              </View>
            </View>
            {/* row 3 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>3</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Ajeer</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.ajeer}</Text>
              </View>
            </View>
            {/* row 4 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>4</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Date</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                {/* <Text break>{propData?.created_at}</Text> */}
                <Text break>
                  {/* {propData?.created_at ? new Date(propData.created_at).toISOString().split('T')[0] : ''} */}
                  {propData?.created_at
                    ? new Date(propData?.created_at)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </Text>
              </View>
            </View>
            {/* row 5 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>5</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Sponsor ID</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.sponsor_id}</Text>
              </View>
            </View>
            {/* row 6 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>6</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Nationality</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.Nationality}</Text>
              </View>
            </View>
            {/* row 7 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>7</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Stamp City</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.visa_stamp_city}</Text>
              </View>
            </View>
            {/* row 8 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>8</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break> Visa Profession </Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.visa_profession}</Text>
              </View>
            </View>
            {/* row 9 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>9</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Gender</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.gender}</Text>
              </View>
            </View>
            {/* row 10 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>10</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Priority For Issuance</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.priority_of_issuance}</Text>
              </View>
            </View>
            {/* row 11 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>11</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Total Visas</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.total_visa}</Text>
              </View>
            </View>
            {/* row 12 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>12</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Block Number</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.visa_block_number}</Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>13</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Block Issue Date</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                {/* <Text break>{propData?.visa_block_issue_date}</Text> */}
                <Text>
                  {/* {propData?.visa_block_issue_date
                    ? new Date(propData?.visa_block_issue_date)
                        .toISOString()
                        .split("T")[0]
                    : ""} */}
                  {propData?.visa_block_issue_date
                    ? new Date(propData?.visa_block_issue_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>14</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Block Expiry Date</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                {/* <Text break>{propData?.visa_block_expiry_date}</Text> */}
                <Text>
                  {/* {propData?.visa_block_expiry_date
                    ? new Date(propData?.visa_block_expiry_date)
                        .toISOString()
                        .split("T")[0]
                    : ""} */}
                  {propData?.visa_block_expiry_date
                    ? new Date(propData?.visa_block_expiry_date)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .split(" ")
                        .join("-")
                        .toUpperCase()
                    : "-----"}
                </Text>
              </View>
            </View>
            {/* row 13 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>15</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Visa Service Charge (SAR)</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.visa_service_charge}</Text>
              </View>
            </View>
            {/* row 14 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>16</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Payment Terms For Visas</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.payment_terms_for_visa}</Text>
              </View>
            </View>
            {/* row 15 */}
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>17</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Payment Terms For Post Arrivals</Text>
              </View>
              <View style={{ width: "50%", padding: 10 }}>
                <Text break>{propData?.payment_terms_for_post_arrival}</Text>
              </View>
            </View>
            <View
              style={{
                flexDirection: "row",
                borderTop: 0.5,
                borderBottom: 0.5,
                borderLeft: 1,
                borderRight: 1,
              }}
            >
              <View style={{ width: "5%", borderRight: 1, padding: 10 }}>
                <Text break>18</Text>
              </View>
              <View style={{ width: "40%", borderRight: 1, padding: 10 }}>
                <Text break>Signature (Operations)</Text>
                <Text break>Date:</Text>
              </View>
            </View>
          </View>
        </PageLayout>
      </Document>
    </>
  );
}
